import { render } from "./OrderExpanded.vue?vue&type=template&id=1e0d1de9&scoped=true"
import script from "./OrderExpanded.vue?vue&type=script&lang=js"
export * from "./OrderExpanded.vue?vue&type=script&lang=js"

import "./OrderExpanded.vue?vue&type=style&index=0&id=1e0d1de9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0d1de9"]])

export default __exports__